export default __webpack_public_path__ + "static/media/doc-contabili.49c08315.svg";